import { getToken, validateAndExtractData } from './api.base.service';

export const getReport = async (reportType: string) => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}reports/${reportType}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const reportData = await validateAndExtractData(response);
  return reportData;
};